// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-container {
    padding: 20px;
  }
  
  .upload-container h2 {
    margin-bottom: 20px;
  }
  
  .upload-options {
    display: flex;
    gap: 30px;
  }
  
  .option-category {
    flex: 1 1;
  }
  
  .option-category h3 {
    font-size: 1.2em;
    margin-bottom: 10px;
  }
  
  .option-card {
    background-color: #f8f9fa;
    padding: 20px;
    margin-bottom: 10px;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .option-card:hover {
    background-color: #e9ecef;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/upload.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".upload-container {\n    padding: 20px;\n  }\n  \n  .upload-container h2 {\n    margin-bottom: 20px;\n  }\n  \n  .upload-options {\n    display: flex;\n    gap: 30px;\n  }\n  \n  .option-category {\n    flex: 1;\n  }\n  \n  .option-category h3 {\n    font-size: 1.2em;\n    margin-bottom: 10px;\n  }\n  \n  .option-card {\n    background-color: #f8f9fa;\n    padding: 20px;\n    margin-bottom: 10px;\n    text-align: center;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .option-card:hover {\n    background-color: #e9ecef;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
